<template>
  <section id="partner" class="partner">
    <div class="container">
      <div class="section-caption">{{ $t("partner_headline") }}</div>
      <div class="caption-partner">
        {{ $t("partner_tagline") }}
      </div>
      <VueSlickCarousel
        v-bind="slickOptions"
        v-if="partners.length > 0"
        v-vpshow-scroll="'slide-bottom'"
      >
        <div v-for="(partner, index) in partners" :key="index" class="card-patner">
          <div class="col-md-6">
            <b-row>
              <img
                :src="partner.image_jpg"
                :alt="partner.partner_name"
                class="feature-img center"
                v-vpshow-scroll
              />
            </b-row>
          </div>
        </div>
        <template #prevArrow="">
          <button class="slick-custom-arrow slick-custom-arrow-left">
            <i class="fas fa-chevron-left"></i>
          </button>
        </template>
        <template #nextArrow="">
          <button class="slick-custom-arrow slick-custom-arrow-right">
            <i class="fas fa-chevron-right"></i>
          </button>
        </template>
        <template #customPaging="page">
          <button>
            {{page}}
          </button>
        </template>
      </VueSlickCarousel>
    </div>

    <div class="container" style="margin:auto;padding-top:100px;text-align: center;">
      <div class="patner-title">
        {{ $t("getintouch") }}
      </div>
      <br />
      <div class="patner-title-content">
        {{ $t("getintouch_tagline") }}
      </div>
      <b-button
        href="mailto:salescorp@paxel.co"
        style="background-color: #5e51a1"
      >
        <img src="@/assets/images/ic-email.svg" alt="" />
        salescorp@paxel.co
      </b-button>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// import PaxelLoader from '@/components/PaxelLoader.vue';

export default {
  name: 'Partner',
  components: {
    VueSlickCarousel,
    // PaxelLoader,
  },
  data() {
    return {
      visible: false,
      partners: [],
      morePartner: [],
      loadingBanner: true,
      slickOptions: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        rows: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$store.dispatch('fetchPartnerpage', {
      language: this.$store.getters.getLanguage,
      limit: 100,
      search_param: '',
      page: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepagePartner,
      (newValue) => {
        this.loadingBanner = true;
        this.partners = newValue;
        this.loadingBanner = false;
      },
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch('fetchPartnerpage', {
          language: newValue,
          limit: 100,
          search_param: '',
          page: 1,
        });
      },
    );
  },
};
</script>
<style scoped>
.patner-title {
  font-family: "GothamBold";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
}
.patner-title-content {
  margin: 10px 0 20px;
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  text-align: center;
  color: #424143;
}
.mobile-home .partner {
  padding: 0px;
}
.mobile-home section .section-caption {
  /*width: 155px;
  height: 22px;*/
  margin: 0 90px 10px 0;
  font-family: "GothamBold";
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5e50a1;
}
.mobile-home .caption-partner {
  width: 262px;
  height: 66px;
  margin: 10px 1px 10px 0;
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #424143;
}
.mobile-home .feature-img {
  width: 90px;
  height: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.feature-headline {
  text-align: center;
}
.card-patner {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  /* border: 1px solid rgba(0, 0, 0, 0.125); */
  /* border-radius: 0.25rem; */
  padding: 41px 20px 41px 21px;
  border-radius: 10px;
}
</style>
